import React from 'react';

import PropTypes from 'prop-types';
import { Button, Stack, Typography } from '@mui/material';
import Iconify from 'src/components/iconify/iconify';

function ShortcutRow({ shortcut, onClick }) {
  return (
    <Button fullWidth onClick={onClick}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        justifyContent="flex-start"
        width="100%"
      >
        <Iconify icon={shortcut.icon} width={24} />
        <Stack direction="column" alignItems="flex-start" width="100%">
          <Typography variant="subtitle1">{shortcut.primary}</Typography>
          <Typography variant="caption" color="textSecondary">
            {shortcut.detail}
          </Typography>
        </Stack>
      </Stack>
    </Button>
  );
}

ShortcutRow.propTypes = {
  shortcut: PropTypes.shape({
    primary: PropTypes.string.isRequired,
    detail: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ShortcutRow;
